import * as React from 'react';
import { Paper, TextField, Fab } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  paperForm: {
    padding: 20,
  },
  textfieldMargin: {
    marginTop: 20,
  },
}));

const MAX_MSG_CHARACTERS = 240;
const MAX_SENDER_CHARACTERS = 100;

export interface GiftCardFormData {
  senderName: string;
  message: string;
}

export interface GiftCardFormProps {
  submitted: boolean;
  defaultFormData?: GiftCardFormData;
  onFormDataChanged?: (data: GiftCardFormData) => void;
  onSubmit: () => void;
}

type ChangeEvent = React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>;

const GiftCardForm: React.FC<GiftCardFormProps> = ({
  onFormDataChanged,
  onSubmit,
  submitted,
  defaultFormData,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t } = useTranslation();
  const { classes } = useStyles();

  const [senderHelpText, setSenderHelpText] = React.useState('');
  const [messageHelpText, setMessageHelpText] = React.useState('');

  const senderNameLabel = t('ecard.giftForm.senderLabel').replace(
    '{n}',
    `${MAX_SENDER_CHARACTERS}`,
  );
  const messageLabel = t('ecard.giftForm.messageLabel').replace('{n}', `${MAX_MSG_CHARACTERS}`);

  const handleOnChangeSender = (e: ChangeEvent) => {
    if (e.target.value.length > MAX_SENDER_CHARACTERS) {
      setSenderHelpText(t('ecard.giftForm.senderHelpText'));
      return;
    }
    if (senderHelpText) setSenderHelpText('');

    const newData = {
      senderName: e.target.value,
      message: defaultFormData.message,
    };
    if (onFormDataChanged) onFormDataChanged(newData);
  };

  const handleOnChangeMessage = (e: ChangeEvent) => {
    if (e.target.value.length > MAX_MSG_CHARACTERS) {
      setMessageHelpText(t('ecard.giftForm.messageHelpText'));
      return;
    }
    if (messageHelpText) setMessageHelpText('');

    const newData = {
      senderName: defaultFormData.senderName,
      message: e.target.value,
    };
    if (onFormDataChanged) onFormDataChanged(newData);
  };

  return (
    <Paper className={classes.paperForm} elevation={0}>
      <TextField
        className={classes.textfieldMargin}
        fullWidth
        error={!!senderHelpText}
        helperText={senderHelpText}
        label={senderNameLabel}
        variant="outlined"
        multiline
        value={defaultFormData.senderName}
        onChange={handleOnChangeSender}
      />
      <TextField
        className={classes.textfieldMargin}
        fullWidth
        label={messageLabel}
        error={!!messageHelpText}
        helperText={messageHelpText}
        variant="outlined"
        multiline
        value={defaultFormData.message}
        onChange={handleOnChangeMessage}
      />
      <p style={{ marginTop: 20 }}>{t('ecard.giftForm.readyInfo')}</p>
      <Fab
        type="submit"
        variant="extended"
        size="medium"
        color="primary"
        disabled={submitted}
        style={{ marginTop: 10 }}
        onClick={onSubmit}
      >
        {t('ecard.giftForm.purchaseBtn')}
      </Fab>
    </Paper>
  );
};

export default GiftCardForm;
